var config$1;
function setConfig(configuration) {
    config$1 = configuration;
}
function getConfig() {
    if (!hasConfiguration$1()) {
        throw new Error('Attempting to access configuration before it was set');
    }
    return config$1;
}
function hasConfiguration$1() {
    return config$1 !== undefined;
}

/**
 * @description Sets raw remote configuration
 */
function setRawRemoteConfig(configuration) {
    config = configuration;
}
/**
 * @description Provides access to raw remote configuration
 */
function getRawRemoteConfig() {
    if (!hasConfiguration()) {
        throw new Error('Attempting to access remote configuration before it was set');
    }
    return config;
}
var config;
function hasConfiguration() {
    return config !== undefined;
}

var LaunchDarklyProject;
(function (LaunchDarklyProject) {
    LaunchDarklyProject["DefaultProject"] = "DefaultProject";
    LaunchDarklyProject["ServiceStatus"] = "ServiceStatus";
    LaunchDarklyProject["Surveys"] = "Surveys";
})(LaunchDarklyProject || (LaunchDarklyProject = {}));

var ProductType;
(function (ProductType) {
    ProductType["Casino"] = "Casino";
    ProductType["CasinoLive"] = "CasinoLive";
    ProductType["Virtual"] = "Virtual";
    ProductType["Sport"] = "Sport";
    ProductType["SportSpecials"] = "SportSpecials";
    ProductType["Lotto"] = "Lotto";
    ProductType["News"] = "News";
    ProductType["Shops"] = "Shops";
    ProductType["SuperSpin"] = "SuperSpin";
    ProductType["Base"] = "Base";
})(ProductType || (ProductType = {}));

var BetSlipPurchaseType;
(function (BetSlipPurchaseType) {
    BetSlipPurchaseType["online"] = "online";
    BetSlipPurchaseType["offline"] = "offline";
})(BetSlipPurchaseType || (BetSlipPurchaseType = {}));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** @class */ ((function (_super) {
    __extends(TicketSubmitValidationError, _super);
    function TicketSubmitValidationError(errors) {
        var _newTarget = this.constructor;
        var _this = _super.call(this) || this;
        _this.errors = errors;
        // we need this if we wanna correct instanceof behaviour
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TicketSubmitValidationError;
})(Error));

var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Success"] = "success";
    PaymentStatus["Cancel"] = "cancel";
    PaymentStatus["Pending"] = "pending";
    PaymentStatus["Failed"] = "failed";
    PaymentStatus["Error"] = "failed";
})(PaymentStatus || (PaymentStatus = {}));

var TransactionStatusType;
(function (TransactionStatusType) {
    TransactionStatusType["Success"] = "success";
    TransactionStatusType["Pending"] = "pending";
    TransactionStatusType["Failed"] = "failed";
    TransactionStatusType["Cancel"] = "cancel";
})(TransactionStatusType || (TransactionStatusType = {}));

var TransactionType;
(function (TransactionType) {
    TransactionType["Deposit"] = "deposit";
    TransactionType["Withdrawal"] = "withdrawal";
})(TransactionType || (TransactionType = {}));

var Locale$1;
(function (Locale) {
    Locale["English"] = "en-GB";
    Locale["EnglishBelgian"] = "en-BE";
    Locale["EnglishBrazilian"] = "en-BR";
    Locale["Romanian"] = "ro-RO";
    Locale["Polish"] = "pl-PL";
    Locale["Serbian"] = "sr-Latn-RS";
    Locale["DutchBelgian"] = "nl-BE";
    Locale["FrenchBelgian"] = "fr-BE";
    Locale["PortugueseBrazilian"] = "pt-BR";
    Locale["Bulgarian"] = "bg-BG";
})(Locale$1 || (Locale$1 = {}));
var IsoLanguageCode$1;
(function (IsoLanguageCode) {
    IsoLanguageCode["England"] = "en";
    IsoLanguageCode["Romania"] = "ro";
    IsoLanguageCode["Poland"] = "pl";
    IsoLanguageCode["Serbian"] = "rs";
    IsoLanguageCode["Dutch"] = "nl";
    IsoLanguageCode["French"] = "fr";
    IsoLanguageCode["Portuguese"] = "pt";
    IsoLanguageCode["Bulgarian"] = "bg";
})(IsoLanguageCode$1 || (IsoLanguageCode$1 = {}));

var Country;
(function (Country) {
    Country["Ro"] = "ro";
    Country["Pl"] = "pl";
    Country["Com"] = "com";
    Country["Rs"] = "rs";
    Country["Be"] = "be";
    Country["Bg"] = "bg";
    Country["Br"] = "br";
    Country["BrSocial"] = "brsocial";
    Country["RoNapoleon"] = "ronapoleon";
})(Country || (Country = {}));

var ExperimentType;
(function (ExperimentType) {
    ExperimentType["Device"] = "device";
    ExperimentType["Player"] = "player";
})(ExperimentType || (ExperimentType = {}));

var PaymentLinkType = {
    Static: 'Static',
    External: 'External',
};
var PushNotificationType = {
    ServerSentEvent: 'ServerSentEvent',
    NotificationSocketService: 'NotificationSocketService',
};

var Locale;
(function (Locale) {
    Locale["English"] = "en-GB";
    Locale["EnglishBelgian"] = "en-BE";
    Locale["EnglishBrazilian"] = "en-BR";
    Locale["Romanian"] = "ro-RO";
    Locale["Polish"] = "pl-PL";
    Locale["Serbian"] = "sr-Latn-RS";
    Locale["DutchBelgian"] = "nl-BE";
    Locale["FrenchBelgian"] = "fr-BE";
    Locale["PortugueseBrazilian"] = "pt-BR";
    Locale["Bulgarian"] = "bg-BG";
})(Locale || (Locale = {}));
var IsoLanguageCode;
(function (IsoLanguageCode) {
    IsoLanguageCode["England"] = "en";
    IsoLanguageCode["Romania"] = "ro";
    IsoLanguageCode["Poland"] = "pl";
    IsoLanguageCode["Serbian"] = "rs";
    IsoLanguageCode["Dutch"] = "nl";
    IsoLanguageCode["French"] = "fr";
    IsoLanguageCode["Portuguese"] = "pt";
    IsoLanguageCode["Bulgarian"] = "bg";
})(IsoLanguageCode || (IsoLanguageCode = {}));

var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection || (OrderDirection = {}));
var HandlingFeeMethod;
(function (HandlingFeeMethod) {
    HandlingFeeMethod[HandlingFeeMethod["TaxOnNet"] = 2] = "TaxOnNet";
    HandlingFeeMethod[HandlingFeeMethod["TaxOnGross"] = 3] = "TaxOnGross";
})(HandlingFeeMethod || (HandlingFeeMethod = {}));
var WinTaxMethod;
(function (WinTaxMethod) {
    WinTaxMethod[WinTaxMethod["OneStep"] = 1] = "OneStep";
    WinTaxMethod[WinTaxMethod["MultiStep"] = 2] = "MultiStep";
})(WinTaxMethod || (WinTaxMethod = {}));
var IntroPageType;
(function (IntroPageType) {
    IntroPageType["Disabled"] = "Disabled";
    IntroPageType["ShowOnce"] = "ShowOnce";
    IntroPageType["ShowEveryTime"] = "ShowEveryTime";
})(IntroPageType || (IntroPageType = {}));
var IntroPageRetentionVisibility;
(function (IntroPageRetentionVisibility) {
    IntroPageRetentionVisibility["LoggedState"] = "LoggedState";
    IntroPageRetentionVisibility["ReturningUserState"] = "ReturningUserState";
})(IntroPageRetentionVisibility || (IntroPageRetentionVisibility = {}));

// These are DUPLICATED. They should *not* live here.
// As soon as there is a shared model interface/type/enum library
// we must get it from there.
var BonusDetail;
(function (BonusDetail) {
    BonusDetail["BonusAmount"] = "bonusAmount";
    BonusDetail["RedeemedAmount"] = "redeemedAmount";
    BonusDetail["WageringRequirements"] = "wageringRequirements";
    BonusDetail["WageredAmount"] = "wageredAmount";
    BonusDetail["AmountLeftToWager"] = "amountLeftToWager";
    BonusDetail["SpinCasinoDetail"] = "spinCasinoDetail";
    BonusDetail["AcceptanceDate"] = "acceptanceDate";
    BonusDetail["ActivationDate"] = "activationDate";
    BonusDetail["TermsAndConditionsUrl"] = "termsAndConditionsUrl";
    BonusDetail["ExpirationDate"] = "expirationDate";
    BonusDetail["AmountGained"] = "amountGained";
})(BonusDetail || (BonusDetail = {}));
var BonusProvider;
(function (BonusProvider) {
    BonusProvider["Betler"] = "Betler";
    BonusProvider["Comtrade"] = "Comtrade";
})(BonusProvider || (BonusProvider = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["Id"] = "Id";
    DocumentType["Passport"] = "Passport";
    DocumentType["AdditionalDocument"] = "AdditionalDocument";
    DocumentType["Unknown"] = "Unknown";
})(DocumentType || (DocumentType = {}));
var WithdrawalType;
(function (WithdrawalType) {
    WithdrawalType["Online"] = "online";
    WithdrawalType["OnlinePix"] = "onlinePix";
    WithdrawalType["Instant"] = "instant";
    WithdrawalType["BankTransfer"] = "bankTransfer";
    WithdrawalType["Shop"] = "shop";
    WithdrawalType["PaySafeCard"] = "paySafeCard";
    WithdrawalType["Transaks"] = "transaks";
})(WithdrawalType || (WithdrawalType = {}));
var DepositType;
(function (DepositType) {
    DepositType["Online"] = "online";
    DepositType["OnlineAlternative"] = "onlineAlternative";
    DepositType["BankTransfer"] = "bankTransfer";
    DepositType["Shop"] = "shop";
    DepositType["PaySafeCard"] = "paySafeCard";
    DepositType["PaySpot"] = "paySpot";
    DepositType["Transaks"] = "transaks";
})(DepositType || (DepositType = {}));
var HistoryType;
(function (HistoryType) {
    HistoryType["bets"] = "bets";
    HistoryType["casinoPlays"] = "casinoPlays";
    HistoryType["transactions"] = "transactions";
    HistoryType["liveDealer"] = "liveDealer";
    HistoryType["allTransactions"] = "allTransactions";
})(HistoryType || (HistoryType = {}));

export { Country, DocumentType, HandlingFeeMethod, IntroPageRetentionVisibility, IntroPageType, IsoLanguageCode, LaunchDarklyProject, Locale, OrderDirection, PaymentLinkType, PushNotificationType, WinTaxMethod, getConfig, getRawRemoteConfig, setConfig, setRawRemoteConfig };
//# sourceMappingURL=index.esm.js.map
